module.exports = __webpack_public_path__ + "img/752429d.png";